export const createWeeks = (days = 0, t: (key: 'days' | 'weeks') => string) => {
  if (Number.isInteger(days / 7)) {
    return `${days / 7} ${t('weeks')}`;
  }
  return `${days} ${t('days')}`;
};
